import {
  CreateTick,
  PayoutPlanAffectedYes as PayoutPlanAffectedYesIcon,
  PayoutPlanAffectedNo as PayoutPlanAffectedNoIcon,
} from 'common/components/svgs';
import { Table } from 'antd';
import React from 'react';
import { dayFormatType, formatDay } from '~helpers/day';
import { EDIT } from '../../constant';

const ListView = ({
  setVisibleFn,
  loading,
  data,
  setSelectedPayoutPlanItem,
  pagination,
  setPagination,
  role,
}) => {
  async function handleTableChange(page) {
    const { current, pageSize } = page;
    setPagination({
      ...pagination,
      current,
      pageSize,
    });
  }

  const columns = [
    {
      title: 'Payout Plan Name',
      dataIndex: 'name',
      key: 'name',
      render(text) {
        return <div style={{ wordWrap: 'break-word', wordBreak: 'break-word' }}>{text}</div>;
      },
      width: 180,
    },
    {
      title: 'Applied Country',
      dataIndex: 'country',
      key: 'country',
      render(text) {
        return <div>{text?.name}</div>;
      },
      width: 120,
    },
    {
      title: 'Percentage Paid after Bookings Completed',
      dataIndex: 'bookingCompletedPercent',
      key: 'bookingCompletedPercent',
      width: 120,
      render(text, node) {
        return (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {text}%
            {node.affectedLandlordCommission?.bookingCompleted ? (
              <PayoutPlanAffectedYesIcon className="ml-8" />
            ) : (
              <PayoutPlanAffectedNoIcon className="ml-8" />
            )}
          </div>
        );
      },
    },
    {
      title: 'Percentage Paid after Landlord Commission Paid',
      dataIndex: 'bookingPaidPercent',
      key: 'bookingPaidPercent',
      width: 120,
      render(text, node) {
        return (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {text}%
            {node.affectedLandlordCommission?.bookingPaid ? (
              <PayoutPlanAffectedYesIcon className="ml-8" />
            ) : (
              <PayoutPlanAffectedNoIcon className="ml-8" />
            )}
          </div>
        );
      },
    },
    {
      title: 'Default',
      dataIndex: 'default',
      key: 'default',
      width: 50,
      render(text) {
        if (!text) return null;
        return <CreateTick width="16" height="12" fill="#38B2A6" />;
      },
    },
    {
      title: 'Updated',
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      width: 70,
      render(text, record) {
        return (
          <div style={{ width: '100px' }}>
            <div style={{ whiteSpace: 'nowrap' }}>
              {text && formatDay(dayFormatType.UKWITHHM, text)},&nbsp;by
            </div>
            &nbsp;
            {record?.updatedByCmsUser?.firstName}&nbsp;
            {record?.updatedByCmsUser?.lastName}
          </div>
        );
      },
    },
    ...(role !== 'bd'
      ? [
          {
            title: 'Action',
            dataIndex: 'Action',
            key: 'Action',
            width: 90,
            render(text, record) {
              return (
                <div
                  className="edit-btn"
                  onClick={() => {
                    setVisibleFn(true, EDIT);
                    setSelectedPayoutPlanItem(record);
                  }}
                >
                  Edit
                </div>
              );
            },
          },
        ]
      : []),
  ];
  return (
    <div className="list">
      <Table
        columns={columns}
        dataSource={data}
        loading={loading}
        pagination={pagination}
        onChange={handleTableChange}
        rowKey={record => {
          return record.id;
        }}
      />
    </div>
  );
};

export default React.memo(ListView);
